import { useQuery } from '@tanstack/react-query';

import { IWidgetCard } from '@entities/widget-card/model/types';
import { widgetShopApi } from '@entities/widget-shop/api';

export const useGetPaymentWidgetDataQuery = ({
    widgetId,
    enabled = true,
}: {
    widgetId: IWidgetCard['id'] | null;
    enabled?: boolean;
}) => {
    const { data, isSuccess, isPending, isFetching, isLoading, isFetched } = useQuery({
        ...widgetShopApi.getWidgetPaymentDataQueryOptions({
            widgetId: widgetId as IWidgetCard['id'],
        }),
        enabled: !!widgetId && enabled,
    });

    return {
        data,
        isSuccess,
        isPending,
        isFetching,
        isLoading,
        isFetched,
    };
};
